import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './AdminFooter.css';

class AdminFooter extends Component {
  render() {
    const siteName = 'Yoodlize';
    return (
      <div className={s.footerContainer}>
        Copyright &copy; <b>{siteName}.</b> All rights reserved.
      </div>
    );
  }
}

const mapState = state => ({
  state,
});

const mapDispatch = {};

export default withStyles(s)(
  connect(
    mapState,
    mapDispatch,
  )(AdminFooter),
);



// WEBPACK FOOTER //
// ./src/components/siteadmin/AdminFooter/AdminFooter.js